module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-sleet-a769a73a.svg";